import React from "react";
import { Box, Stack, Text } from "@origin-digital/ods-core";
import { IconChevronRight } from "@origin-digital/ods-icons";
import { InteractiveBox } from "src/components/FeedContainer";
import { ProjectsTableRow } from "../types";
import { useProjectNavigation } from "../hooks";

export const ProjectBox = ({ row }: { row: ProjectsTableRow }) => {
  const { goToPremisesByProject } = useProjectNavigation();
  return (
    <InteractiveBox
      padding="medium"
      borderRadius="xsmall"
      tabIndex={0}
      style={{
        cursor: "pointer",
        transition: "background-color 0.2s ease-in-out",
        outline: "none",
      }}
      onClick={() => goToPremisesByProject(row)}
      data-id={`projectBox.${row.id}.root`}
    >
      <Box display="flex" alignItems="flex-start" gap="medium">
        {/* Project name/ID */}
        <Stack space="xxsmall">
          <Text
            tone="neutral"
            weight="medium"
            data-id={`projectBox.${row.id}.name`}
          >
            {row.name}
          </Text>
          <Text tone="neutralLight" data-id={`projectBox.${row.id}.id`}>
            {row.id}
          </Text>
        </Stack>
        {/* End Project name/ID */}
        {/* Chevron */}
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          paddingTop="xxsmall"
        >
          <IconChevronRight color="grey300" size="xsmall" />
        </Box>
      </Box>
    </InteractiveBox>
  );
};
